/* eslint-disable */
import { PropsWithChildren, createRef } from "react";
import { CloseIcon } from "./icons";

export type ModalProps = {
  title?: string;
  buttons?: { title: string; onClick: () => void }[];
  onClose?: () => void;
  backgroundTransparency: 30 | 50 | 60 | 80;
};

export const Modal = ({
  backgroundTransparency,
  onClose,
  children,
}: PropsWithChildren<ModalProps>) => {
  let opacityClass = "bg-opacity-60";
  switch (backgroundTransparency) {
    case 30:
      opacityClass = "bg-opacity-30";
      break;
    case 50:
      opacityClass = "bg-opacity-50";
      break;
    case 60:
      opacityClass = "bg-opacity-60";
      break;
    case 80:
      opacityClass = "bg-opacity-80";
      break;
  }
  const blanketRef = createRef<HTMLDivElement>();

  const onOutsideClick = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    if (e.target !== blanketRef.current) return;

    e.stopPropagation();
    if (onClose) onClose();
  };

  return (
    <div className={`modal-backdrop ${opacityClass}`} onClick={onOutsideClick} ref={blanketRef}>
      <div className="modal-container h-full flex flex-col justify-center">
        <div className="w-full py-3 flex justify-end items-center" onClick={onClose}>
          <CloseIcon className="fill-white stroke-white w-9 h-9" />
        </div>
        <div className="modal">{children}</div>
      </div>
    </div>
  );
};
